export default "__VITE_ASSET__Cys5grjc__"